import React from 'react';
import {Box} from '@mui/material';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import LinkIcon from '@mui/icons-material/Link';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';

export interface BuilderWithdrawalInfoCaptureProps {
  // Withdrawal (bank account linked to nominated account)
  linked?: boolean;
  // Withdrawal (bank account validated)
  validatedBank?: boolean;
  // Withdrawal (bank account needs linking)
  needsLink?: boolean;
}

export const BuilderWithdrawalSummaryValidation: React.FC<{
  needsLink: boolean;
  validated: boolean;
  linked: boolean;
}> = ({linked, needsLink, validated}) => {
  if (!needsLink) {
    return null;
  }
  if (linked) {
    if (validated) {
      return (
        <Box pl={1} display="flex" flexWrap="wrap" alignContent="center">
          <LinkIcon fontSize="small" />
          <Box ml={0.5} />
          Linked and validated
        </Box>
      );
    }
    return (
      <Box pl={1} display="flex" flexWrap="wrap" alignContent="center">
        <LinkIcon fontSize="small" />
        <Box ml={0.5} /> Linked but not validated
      </Box>
    );
  }

  if (validated) {
    return (
      <Box pl={1} display="flex" flexWrap="wrap" alignContent="center">
        <LinkOffIcon fontSize="small" />
        <Box ml={0.5} /> Validated but not linked
      </Box>
    );
  }
  return (
    <Box pl={1} display="flex" flexWrap="wrap" alignContent="center">
      <GppMaybeIcon fontSize="small" />
      <Box ml={0.5} /> Not validated, not linked
    </Box>
  );
};
